import { useSelector } from "react-redux";

function useFormularioInscripcion() {
  const publico = useSelector(({ iframe }) => iframe.iframeConfig.publico);
  return { privado: !publico };
}

export default useFormularioInscripcion;
